import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { uploadFile } from '../request';
import { getBase64, isImage, isVideo, isPDF, isExcel, isWord } from '@/views/claim/demageManage/utils';
import previewModal from '@/views/claim/demageManage/previewModal.vue';
const MAX_SIZE = 50; // MB
const MAX_VIDEO_SIZE = 300; // MB
export default {
  props: {
    // 每个数据的index
    indexID: {
      type: Number,
      default: 0
    },
    // 每个数据
    itemID: {
      type: Object,
      default: () => {}
    },
    // 提交的数据
    formDataID: {
      type: Object,
      default: () => {}
    },
    // 校验
    rulesTrueID: {
      type: Object,
      default: () => {}
    },
    // 整个数据
    formDataArrayID: {
      type: Array,
      default: () => []
    }
  },
  components: {
    previewModal // 声明组件
  },
  data() {
    return {
      action: uploadFile,
      allowedFileTypes: ['.xlsx', '.xls', '.docx', '.doc', '.rm', '.mp4', '.rmvb', '.avi', '.jpg', '.pdf', '.jpeg', '.png'],
      uploadAccept: '',
      checkAll: false,
      indeterminate: false,
      fileDialog: false,
      previewVisible: false,
      previewSrc: '',
      previewPDF: '',
      previewXLSX: '',
      previewDocx: '',
      isPDFShow: false,
      isxlsxShow: false,
      isShow: '',
      currentPreviewIndex: 0
    };
  },
  computed: {
    index() {
      return this.indexID;
    },
    item() {
      return this.itemID;
    },
    formData() {
      console.log(this.formDataID, '-----this.formDataID------');
      return this.formDataID;
    },
    rulesTrue() {
      return this.rulesTrueID;
    },
    formDataArray() {
      return this.formDataArrayID;
    }
    // shouldShowUploadIcon() {
    //   return this.formDataArray.fileListData.length < 2;
    // }
  },
  created() {
    // console.log('获取传过来777777777的数据--', this.formDataArray);
  },
  mounted() {},
  methods: {
    // 禁止输入负数
    parseNonNegativeNumber(value) {
      const parsedValue = parseFloat(value);
      if (isNaN(parsedValue) || parsedValue < 0) {
        return 0; // 设置为默认值或其他非负数
      }
      return parsedValue;
    },
    // 单选
    onChangeFormat(index) {
      this.toChangeUploadAccept(this.formDataArray[index].fileFormat);
      // console.log('获取文件-------格式----', this.formDataArray[index].fileFormat);
    },
    // 结束
    // 设置上传文件限制格式
    toChangeUploadAccept(data) {
      // console.log(data, '设置上传文件限制格式');
      if (data.length) {
        data = data.map(i => '.' + i);
        this.uploadAccept = data.join(',');
      } else {
        this.uploadAccept = 'image/*';
      }
    },
    // 当输入框被清空时，parseInt() 函数会返回 NaN（Not a Number），
    handleInputBlur(fileNumber) {
      if (!fileNumber.value || isNaN(fileNumber.value)) {
        fileNumber.value = 2; // 设置默认值为 2 或其他合适的值
      }
    },
    fileSizeBlur(fileSize) {
      if (!fileSize.size || isNaN(fileSize.size)) {
        fileSize.size = 1; // 设置默认值为 1 或其他合适的值
      }
    },
    formatInteger(value) {
      return value ? String(parseInt(value)) : '';
    },
    // 设置上传文件限制格式
    toChangeUploadAccept(data) {
      // console.log(data, '设置上传文件限制格式');
      if (data.length) {
        data = data.map(i => '.' + i);
        this.uploadAccept = data.join(',');
      } else {
        this.uploadAccept = 'image/*';
      }
    },
    isFileSizeValid(file, maxSize) {
      return file.size / 1024 / 1024 < maxSize;
    },
    // 文件上传逻辑
    clickPlusTWO(index) {
      // this.indexQJ = index;
      // // 文件的类型的数据
      // if (this.formDataArray[index].fileFormat.length == 0) {
      //   this.$message.error(this.$t('请选择文件格式'));
      //   return;
      // }
    },
    changeUploadTwo({
      file,
      fileList
    }) {
      // if (this.formDataArray[index].fileFormat.length == 0) {
      //   this.$message.error(this.$t('请选择文件格式'));
      //   return;
      // }
      // const isVideoFile = isVideo(file.name);
      // const maxSize = isVideoFile ? MAX_VIDEO_SIZE : MAX_SIZE;
      // if (!this.isFileSizeValid(file, maxSize)) {
      //   const errorMessage = this.$t(isVideoFile ? '视频最大不超300M' : '文件最大不超50M');
      //   this.$message.error(errorMessage);
      //   return;
      // }
      // const fileType = file.name.substring(file.name.lastIndexOf('.')).substring(1);
      // // 文件类型
      // if (!this.formDataArray[index].fileFormat.includes(fileType)) {
      //   this.$message.error(this.$t('请选择文件格式'));
      //   return;
      // }
      // 文件列表
      this.formDataArray[this.index].fileListData = fileList.map(item => {
        if (item.response && item.response.code === 200 && item.status === 'done') {
          item.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(item.response.data).fileTempUrl : item.response.data.fileTempUrl;
          // 将文件URL添加到templateUrl变量中
          // this.formDataArray[index].templateUrl += item.url + ',';
        }
        // return item; //获取文件全部属性数据
        return {
          uid: item.uid,
          name: item.name,
          url: item.url,
          status: item.status,
          // thumbUrl: item.thumbUrl,
          response: item.response
        };
      });
      // console.log('获取上传文件数据--------', this.formDataArray[this.index].fileListData);

      this.formDataArray[this.index].templateUrl = this.formDataArray[this.index].fileListData.map(item => item.url);
      // 移除最后一个逗号
      // this.formDataArray[index].templateUrl = this.formDataArray[index].templateUrl.slice(0, -1);
      this.showActionButtons = true;
    },
    async handlePreview(file, fileList) {
      this.isShow = '';
      if (isImage(file.name)) {
        this.isShow = 'image';
      }
      if (isVideo(file.name)) {
        this.isShow = 'video';
      }
      if (isExcel(file.name)) {
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewXLSX = urlid + file.url;
        window.open(this.previewXLSX);
      }
      // doc格式打不开
      if (isWord(file.name)) {
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewDocx = urlid + file.url;
        window.open(this.previewDocx);
      }
      this.isPDFShow = isPDF(file.name);
      this.isxlsxShow = isExcel(file.name);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      if (this.isShow === 'image' || this.isShow === 'video') {
        this.previewSrc = file.url || file.preview;
        this.currentPreviewIndex = this.formDataArray[this.index].templateUrl.indexOf(file);
      } else if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      } else if (this.isxlsxShow) {
        this.previewXLSX = file.url || file.response.data.fileTempUrl;
        window.open(this.previewXLSX);
        return;
      } else {
        window.open(file.url || file.response.data.fileTempUrl);
        return;
      }
      this.previewVisible = true;
    },
    // 附件上传新建
    beforeUpload(file) {
      // const index = this.indexQJ;
      // if (this.formDataArray[index].fileFormat.length < 0) {
      //   this.$message.error('请选择文件格式');
      //   return;
      // }
      // const extension = file.name.split('.').pop().toLowerCase();
      // // "fileFormat": "文件格式：Word Xlsx xls JPG mov jpeg mp4 PDF BMP docx doc rm rmvb avi jpg
      // const isValidType = this.formDataArray[index].fileFormat.includes(extension);
      // // if (!isValidType) {
      // //   this.$message.error(this.$t('无效的文件格式'));
      // // }
      // const isValidSize =
      //   file.size / (this.formDataArray[index].fileSize.type === 'MB' ? 1024 * 1024 : 1024) <
      //   this.formDataArray[index].fileSize.size;
      // if (!isValidSize) {
      //   this.$message.error(this.$t('文件大小超过限制'));
      // }
      // return isValidType && isValidSize;
    },
    // 监听删除
    removeUploadFile(file) {
      const index = this.formDataArray[this.index].templateUrl.indexOf(file);
      const newFileList = this.formDataArray[this.index].templateUrl.slice(); // 将字符串拆分为数组
      // console.log('newFileList type:', typeof newFileList); // 检查newFileList的类型
      // console.log('newFileList:', newFileList); // 输出newFileList的内容
      newFileList.splice(index, 1);
      this.formDataArray[this.index].templateUrl = newFileList; // 将数组转换回字符串
    },
    // 关闭事件
    formeClase(index) {
      this.formDataArray[index].editing = false;
    }
  }
};